module.exports = __webpack_public_path__ + "assets/img/statis-all.5838dea8.svg";